import { Link } from "react-router-dom";
import { ArrowRight, Compass, HardHat, Landmark } from "lucide-react";
import { } from "@/lib/api";
import { Reveal, Shell } from "@/components/layout/Shell";
import { StatsBand } from "@/components/home/Sections";
import { CommitteeGrid } from "@/components/home/Showcase";
import { resolveStats, useBootstrap } from "./Home";

const values = [
  { icon: Landmark, title: "Professional standing", text: "Recognition, representation and a collective voice for diploma civil engineers across the twin cities." },
  { icon: Compass, title: "Continuous learning", text: "Workshops, site visits and technical sessions that keep members current with codes, materials and methods." },
  { icon: HardHat, title: "Service to the region", text: "Community initiatives that channel engineering skill into safer, stronger public infrastructure." }
];

export default function AboutPage() {
  const data = useBootstrap();
  return (
    <Shell>
      <main className="inner-page">
        <section className="section" style={{ paddingTop: 100 }}>
          <div className="container split">
            <Reveal>
              <span className="eyebrow">DCEA / About</span>
              <h2 style={{ fontSize: "clamp(38px,4.6vw,66px)" }}>Built by engineers, <em className="gold-text">for engineers.</em></h2>
              <p className="lead">
                The Diploma Civil Engineers Association, Hubli–Dharwad, brings together practising diploma
                civil engineers from consultancies, contractors, government departments and academia — to share
                knowledge, uphold professional standards and build a stronger region.
              </p>
              <Link to="/membership" className="button button-gold" style={{ marginTop: 30 }} data-testid="about-join-button">
                Join the association <ArrowRight size={15} />
              </Link>
            </Reveal>
            <Reveal delay={0.15} className="about-image">
              <img src="https://images.unsplash.com/photo-1648721506233-63e95c1a0bcc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="Suspension bridge at dusk" data-testid="about-hero-image" />
              <span>Est. Hubli–Dharwad</span>
            </Reveal>
          </div>
          <div className="container values-grid">
            {values.map(({ icon: Icon, title, text }, i) => (
              <Reveal key={title} delay={i * 0.1}>
                <article className="value-card" data-testid={`about-value-${i}`}>
                  <Icon size={28} />
                  <h3>{title}</h3>
                  <p>{text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </section>
        {data && <StatsBand stats={resolveStats(data)} />}
        {data && <CommitteeGrid committee={data.committee || []} />}
      </main>
    </Shell>
  );
}
